import React from 'react';
import { generatePath } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import RouterLink from '@/components/common/RouterLink';
import AuthRoutes from '@/constants/routing/AuthRoutes';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { useLifecycleBoard } from '@/modules/LifecycleBoard';

function ConstituentLifecycleBoardListItem({ boardId, columnId, compact }) {
  const { data: board } = useLifecycleBoard(boardId);
  const columnTitle = React.useMemo(
    () => board?.columns.find((col) => col.columnId === columnId)?.columnTitle,
    [board, columnId],
  );

  return board ? (
    <li className={classNames('font-normal', { 'text-sm': compact })}>
      <RouterLink
        to={generatePath(AuthRoutes.BOARD, { boardId })}
        className={classNames('block font-medium', { 'text-sm': compact })}
      >
        {board.boardTitle}
      </RouterLink>
      {columnTitle}
    </li>
  ) : null;
}

ConstituentLifecycleBoardListItem.propTypes = {
  boardId: PropTypes.string.isRequired,
  columnId: PropTypes.string.isRequired,
  compact: PropTypes.bool,
};

ConstituentLifecycleBoardListItem.defaultProps = {
  compact: false,
};

export default ConstituentLifecycleBoardListItem;
